import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g fillOpacity="1">
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 -21.36 766.911)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 .0189 -28.915 764.98)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 -.0189 171.243 1006.744)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 -21.36 1004.813)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.98105 1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M27 735.552l-.711 5.649H7.94q.423-4.86 3.92-8.588l6.224-5.303q3.247-2.804 3.247-5.629 0-1.882-1.076-2.997-1.056-1.133-2.92-1.133-2.152 0-3.208 1.153-.692.768-1.057 2.363-.365 1.69-.576 1.96-.308.095-.711.095h-2.42q-.424 0-.73-.173-.135-.403-.135-.903 0-4.015 2.632-6.378 2.516-2.267 6.55-2.267 3.747 0 6.13 1.998 2.535 2.113 2.535 5.802 0 3.631-2.804 6.647-.98 1.076-5.572 4.592-3.343 2.594-4.111 4.669h8.953l.153-1.73q.212-.922 1.134-.922h1.92q1.115 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.98105 -1.01931)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-211.519-1002.606l-.71 5.648h-18.348q.422-4.86 3.919-8.588l6.225-5.302q3.247-2.805 3.247-5.63 0-1.882-1.076-2.996-1.057-1.134-2.92-1.134-2.152 0-3.209 1.153-.692.768-1.057 2.363-.365 1.69-.576 1.96-.307.095-.71.095h-2.422q-.422 0-.73-.172-.134-.404-.134-.903 0-4.016 2.632-6.379 2.517-2.267 6.551-2.267 3.747 0 6.129 1.998 2.536 2.114 2.536 5.802 0 3.631-2.805 6.648-.98 1.076-5.572 4.591-3.342 2.594-4.11 4.669h8.952l.154-1.73q.21-.921 1.133-.921h1.921q1.115 0 .98 1.095z"
                            fontSize="39.346"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
